<app-layout>
  <app-voltar [route]="onVoltar()" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>
        {{ isMode() === false ? 'Edição de Empresa' : 'Cadastro de Empresa' }}
      </app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form">
      <div class="formList">
        <app-input
          type="text"
          label="Razão social"
          name="NM_RZAO_SOCI_EPSA"
          formControlName="NM_RZAO_SOCI_EPSA"
          maxLength="30"
          [requiredInput]="true"
          placeholder="Digite aqui"></app-input>

        <app-input
          type="text"
          label="CNPJ"
          name="TX_CNPJ_EPSA"
          formControlName="TX_CNPJ_EPSA"
          [requiredInput]="true"
          mask="00.000.000/0000-00"
          placeholder="__.___.___/____-__"></app-input>

        <app-input
          label="Inscrição estadual"
          name="TX_INCR_ESTD_EPSA"
          formControlName="TX_INCR_ESTD_EPSA"
          mask="000.000.000.000"
          placeholder="___.___.___.___"
          placeholder="Digite aqui"></app-input>

        <app-input
          label="Nome fantasia"
          name="NM_FNTS_EPSA"
          formControlName="NM_FNTS_EPSA"
          maxLength="50"
          [requiredInput]="true"
          placeholder="Digite aqui"></app-input>

        <app-input
          label="CEP"
          name="TX_ENDE_CEP_EPSA"
          formControlName="TX_ENDE_CEP_EPSA"
          mask="00000-000"
          placeholder="_____-___"
          [requiredInput]="true"
          (ngModelChange)="consultaCEP()">
        </app-input>

        <app-input
          label="Estado"
          name="TX_ENDE_ESTD_EPSA"
          formControlName="TX_ENDE_ESTD_EPSA"
          maxLength="2"
          [requiredInput]="true"
          placeholder="Digite aqui"></app-input>

        <app-input
          label="Cidade"
          name="TX_ENDE_CDDE_EPSA"
          formControlName="TX_ENDE_CDDE_EPSA"
          maxLength="50"
          [requiredInput]="true"
          placeholder="Digite aqui"></app-input>

        <app-input
          label="Endereço"
          name="TX_ENDE_RUA_EPSA"
          formControlName="TX_ENDE_RUA_EPSA"
          maxLength="50"
          [requiredInput]="true"
          placeholder="Digite aqui"></app-input>

        <app-input
          label="Nome do responsável"
          name="NM_RESP_OPRC_EPSA"
          formControlName="NM_RESP_OPRC_EPSA"
          maxLength="50"
          [requiredInput]="true"
          placeholder="Digite aqui"></app-input>

        <app-input
          type="email"
          label="Email"
          name="TX_MAIL_EPSA"
          formControlName="TX_MAIL_EPSA"
          maxLength="100"
          [requiredInput]="true"
          placeholder="exemplo@exemplo.com.br"></app-input>

        <app-input
          label="Telefone"
          name="NU_TELE_EPSA"
          formControlName="NU_TELE_EPSA"
          mask="(00) 00000-0000"
          [requiredInput]="true"
          placeholder="(__) _____-____"></app-input>

        <app-input
          label="Telefone do financeiro"
          name="NU_TELE_OPRC_EPSA"
          formControlName="NU_TELE_OPRC_EPSA"
          mask="(00) 00000-0000"
          [requiredInput]="true"
          placeholder="(__) _____-____"></app-input>

        <app-input
          type="password"
          label="Senha"
          name="TX_SENH_EPSA"
          formControlName="TX_SENH_EPSA"
          maxLength="15"
          [requiredInput]="this.isMode()"
          (ngModelChange)="confirmacaoSenha()"
          placeholder="Digite aqui"></app-input>

        <app-input
          type="password"
          label="Confirme a senha"
          name="TX_SENH_EPSA_CNFRM"
          formControlName="TX_SENH_EPSA_CNFRM"
          maxLength="15"
          [requiredInput]="this.isMode()"
          (ngModelChange)="confirmacaoSenha()"
          placeholder="Digite aqui"></app-input>

        <div
          class="validators"
          *ngIf="form.controls['TX_SENH_EPSA'].value?.length > 0">
          <p [ngClass]="{ valid: isLengthValid, invalid: !isLengthValid }">
            No mínimo 8 caracteres
          </p>
          <p [ngClass]="{ valid: hasNumber, invalid: !hasNumber }">
            Pelo menos um número
          </p>
          <p [ngClass]="{ valid: hasLowercase, invalid: !hasLowercase }">
            No mínimo 1 caractere minúsculo
          </p>
          <p [ngClass]="{ valid: hasUppercase, invalid: !hasUppercase }">
            No mínimo 1 caractere maiúsculo
          </p>
          <p [ngClass]="{ valid: hasSpecialChar, invalid: !hasSpecialChar }">
            No mínimo 1 caractere especial
          </p>
          <p [ngClass]="{ valid: passwordsMatch, invalid: !passwordsMatch }">
            As senhas devem ser iguais
          </p>
        </div>
      </div>
      <app-botao
        type="cadastro"
        [text]="
          this.isMode() === false ? 'Editar Empresa' : 'Cadastrar Empresa'
        "
        [disabled]="!form.valid"
        (click)="postarDados()"></app-botao>
    </form>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
